import React from 'react';
import { StarIcon } from 'lucide-react';
export function Testimonials() {
  return <section className="py-16 md:py-24 bg-white" data-id="element-226">
      <div className="container mx-auto px-4" data-id="element-227">
        <div className="text-center mb-16" data-id="element-228">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-229">
            Trusted by Entrepreneurs Worldwide
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-230">
            See what foreign business owners are saying about our ITIN
            application service.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-231">
          <div className="bg-white p-8 rounded-lg shadow-md border border-gray-100" data-id="element-232">
            <div className="flex mb-4" data-id="element-233">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="text-yellow-400 fill-current" size={20} data-id="element-234" />)}
            </div>
            <p className="text-gray-700 mb-6" data-id="element-235">
              "The process was incredibly smooth. I received my ITIN within
              weeks and was able to start my e-commerce business in the US
              immediately. The support team was responsive and knowledgeable."
            </p>
            <div className="flex items-center" data-id="element-236">
              <div className="w-12 h-12 rounded-full bg-gray-300 flex items-center justify-center mr-4" data-id="element-237">
                <span className="text-gray-600 font-semibold" data-id="element-238">MR</span>
              </div>
              <div data-id="element-239">
                <h4 className="font-semibold text-gray-900" data-id="element-240">Maria Rodriguez</h4>
                <p className="text-gray-600 text-sm" data-id="element-241">
                  E-commerce Entrepreneur, Spain
                </p>
              </div>
            </div>
          </div>
          <div className="bg-white p-8 rounded-lg shadow-md border border-gray-100" data-id="element-242">
            <div className="flex mb-4" data-id="element-243">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="text-yellow-400 fill-current" size={20} data-id="element-244" />)}
            </div>
            <p className="text-gray-700 mb-6" data-id="element-245">
              "As a digital nomad, getting an ITIN was essential for my US
              clients. TheITIN.com made the process painless. Their expert team
              guided me through every step, and I didn't have to send any
              original documents."
            </p>
            <div className="flex items-center" data-id="element-246">
              <div className="w-12 h-12 rounded-full bg-gray-300 flex items-center justify-center mr-4" data-id="element-247">
                <span className="text-gray-600 font-semibold" data-id="element-248">JC</span>
              </div>
              <div data-id="element-249">
                <h4 className="font-semibold text-gray-900" data-id="element-250">James Chen</h4>
                <p className="text-gray-600 text-sm" data-id="element-251">
                  Software Developer, Singapore
                </p>
              </div>
            </div>
          </div>
          <div className="bg-white p-8 rounded-lg shadow-md border border-gray-100" data-id="element-252">
            <div className="flex mb-4" data-id="element-253">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="text-yellow-400 fill-current" size={20} data-id="element-254" />)}
            </div>
            <p className="text-gray-700 mb-6" data-id="element-255">
              "I was worried about the complexity of getting an ITIN as a
              foreign investor, but TheITIN.com simplified everything. Their
              service was worth every penny and saved me countless hours of
              research and stress."
            </p>
            <div className="flex items-center" data-id="element-256">
              <div className="w-12 h-12 rounded-full bg-gray-300 flex items-center justify-center mr-4" data-id="element-257">
                <span className="text-gray-600 font-semibold" data-id="element-258">AP</span>
              </div>
              <div data-id="element-259">
                <h4 className="font-semibold text-gray-900" data-id="element-260">Anika Patel</h4>
                <p className="text-gray-600 text-sm" data-id="element-261">
                  Real Estate Investor, India
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}